class dataRegister {

    static api = {
        url: 'https://api.devprimehit.com/v2',
    };

    static setApiDomain(value){
        if(value === "primehit" || value === "devprimehit"){
            dataRegister.api.url = "https://api."+value+".com/v2";
        }else{
            dataRegister.api.url = "http://"+value+"/v2";
        }
    }

    static documentLocation() {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET'
            };
            fetch(document.location, data)
                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static getLogo(market, id) {
        return new Promise(function (resolve, reject) {
            let data = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            fetch(dataRegister.api.url + '/' + market + "/static/salesforce/" + id, data)
                .then((response) => {
                    return response.json();
                })
                .then((responseJson) => {
                    resolve(responseJson);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    static logo(market, id) {
        return dataRegister.getLogo(market, id);
    }

}

export { dataRegister }


// WEBPACK FOOTER //
// ./src/services/dataRegister.js